module.exports = __webpack_public_path__ + "media/images/personnel/Marchelle_Green-f8ebb21b160a417bfd1fdd86b1f1b940.png";